export default {
    updateXlsx (state, payload) {
        state.xlsx_data = payload
    },

    updateSelectXlsx(state, payload){
        state.xlsx_select_data = payload
    },

    updateLoading(state, payload){
        state.is_loading = payload
    },

    /**
     * STEP1
     */
    updateItemNumber (state, payload) {
        //初期化
        this.commit('removeSelected','')
        state.step1_data.item_number = payload
        //this.dispatch('priceCheck')
    },
    updateAtomakuItemNumber (state, payload) {
        state.step1_data.atomaku_number = payload
        //this.dispatch('priceCheck')
    },

    updateSearchData (state, payload) {
        state.search_data = payload
        this.dispatch('priceCheck')
    },

    updateAtomakuSearchData (state, payload) {
        state.search_atomaku_data = payload
        this.dispatch('priceAtomakuCheck')
    },
    /**
     * STEP3
     */
    updateOptionSelected(state, payload) {
        state.step3_data[payload.name] = payload.value
        if(!payload.no_check){
            this.dispatch('priceCheck')
        }
    },
    updateUrajiOptionSelected(state, payload) {
        console.log('updateUrajiOptionSelected #2', payload);
        state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][payload.name]['裏地'].option[0].disabled='disabled'
        state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][payload.name]['裏地'].option[1].disabled='disabled'
        console.log('updateUrajiOptionSelected #1', state.xlsx_select_data.select_data)
        if(!payload.no_check){
            this.dispatch('priceCheck')
        }
    },
    /**
     * STEP4
     */
    updateSetNumber(state, payload) {
        state.step4_data.set_number = payload
        this.dispatch('priceCheck')
    },

    /**
     * STEP5
     */
    updateRoomSelected(state, payload) {
        state.step5_data.room_selected = payload
        //this.dispatch('priceCheck')
    },
    updateRoomOtherSelected(state, payload) {
        state.step5_data.other_selected = payload
        //this.dispatch('priceCheck')
    },
    /**
     * 価格情報
     */
    updatePriceData(state, payload){
        state.price_data[payload.name] = payload.value
        //console.log('updatePriceData', payload)
    },
    /**
     * エラーメッセージ
     */
    updateErrorMessage(state, payload){
        state.error_message = payload
    },
    updateAtomakuErrorMessage(state, payload){
        state.atomaku_error_message = payload
    },
    updateCanvasData(state, payload){
        state.canvas_data = payload
    },
    updateNoSelectResult(state, payload){
        state.now_no_select_result = payload
    },

    /**
     * STEP2 スタイル第1階層選択
     * 新しいgroup1と既存のgroup1が異なる場合第2階層リセット
     */
    updateStyleSelected1 (state, payload) {
        this.commit('removeSelected',payload)
        state.step2_data.style_selected2_id = ''
        state.step2_data.style_selected2_name = ''

        state.step2_data.style_selected1_id = payload
        state.step2_data.style_selected1_name = state.xlsx_data.style_data[payload].name
        this.dispatch('priceCheck')
    },

    /**
     * STEP2 スタイル第2階層選択
     * 新しいgroup1と既存のgroup1が異なる場合第1階層リセット
     */
    updateStyleSelected2 (state, payload) {
        this.commit('removeSelected',payload)
        let condition = ''
        if(
            typeof(state.xlsx_data) !=='undefined' &&
            typeof(state.xlsx_data.style_data) !=='undefined' &&
            typeof(state.xlsx_data.style_data[payload]) !=='undefined' &&
            typeof(state.xlsx_data.style_data[payload].condition) !=='undefined'
        ){
            condition = state.xlsx_data.style_data[payload].condition
        }
        if(condition === 'ソフトウェーブ縫製'){
            state.step2_data.style_selected1_id = 1
            state.step2_data.style_selected1_name = state.xlsx_data.style_data[1].name
        }else if(condition === 'スタンダード縫製'){
            state.step2_data.style_selected1_id = 0
            state.step2_data.style_selected1_name = state.xlsx_data.style_data[0].name
        }
        // else if(condition === 'filo縫製'){
        //     state.step2_data.style_selected1_id = 2
        //     state.step2_data.style_selected1_name = state.xlsx_data.style_data[2].name
        // }
        state.step2_data.style_selected2_id = payload
        state.step2_data.style_selected2_name = state.xlsx_data.style_data[payload].name
        this.dispatch('priceCheck')
    },

    /**
     * 初期化
     */
    removeSelected(state, payload){

        //価格初期化
        for(let key in state.price_data){
            state.price_data[key] = ''
        }
        state.price_data.price=0
        state.price_data.price_ura=0
        state.price_data.price_add=0
        state.price_data.price_atomaku=0

        //STEP3初期化
        for(let key in state.step3_data){
            if(key==='width_size' || key === 'height_size'){ continue }
            state.step3_data[key] = ''
        }
        if(payload !== '') {
            if (state.xlsx_data.style_data[payload].group1 !== 'カーテン') {
                state.step3_data.hida = '1倍'
                state.step3_data.open = '片開き'
            }
            if (state.xlsx_data.style_data[payload].group1 === 'ベッドスプレッド') {
                state.step3_data.width_size = ''
                state.step3_data.height_size = ''
            }

            const selected1_id = state.step2_data.style_selected1_id
            if (selected1_id !== '' &&
                state.xlsx_data.style_data[selected1_id].group1 === state.xlsx_data.style_data[payload].group1 ) {
                return false
            }
            if(state.xlsx_data.style_data[payload].group2 !== 'ローマンシェード ツイン'){
                state.step1_data.atomaku_number = ''
            }
        }

        //STEP2初期化
        for(let key in state.step2_data){
            state.step2_data[key] = ''
        }
        state.atomaku_error_message = ''

    }
}